import { render } from "./paymentButton.vue?vue&type=template&id=424ce593&scoped=true"
import script from "./paymentButton.vue?vue&type=script&lang=js"
export * from "./paymentButton.vue?vue&type=script&lang=js"

import "./paymentButton.vue?vue&type=style&index=0&id=424ce593&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424ce593"]])

export default __exports__